<template>
  <Layout>
    <Aguarde :show="httpSend && !carregando"/>

    <div class="fisc-sn">

      <!-- ─── Cabeçalho ──────────────────────────────────────── -->
      <div class="page-intro">
        <div class="page-intro__text">
          <button type="button" class="btn-voltar" @click="voltar">
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
              <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
            Apuração do Simples Nacional
          </button>
          <h2 class="page-intro__title">Detalhamento das divergências</h2>
          <p class="page-intro__sub">
            Divergências apuradas para a empresa selecionada, por competência e tipo de análise.
          </p>
        </div>
      </div>

      <!-- ─── Empresa ───────────────────────────────────────── -->
      <div class="empresa-card">
        <div class="metric-icon metric-icon--blue">
          <span v-html="iconEmpresa()"/>
        </div>
        <div class="empresa-card__body">
          <p class="empresa-card__nome" :class="{ 'cell-primary--ausente': !empresa.nome }">
            {{ empresa.nome || 'Empresa não cadastrada' }}
          </p>
          <p class="empresa-card__info">
            <span class="td-mono">{{ formatCnpj(empresa.cnpj) }}</span>
            <span v-if="empresa.codigo"> · Código {{ empresa.codigo }}</span>
          </p>
        </div>
        <div v-if="!carregando" class="empresa-card__resumo">
          <span class="badge-count">{{ formatInteiro(divergencias.length) }}
            {{ filtros.exercicio === 'todos' ? 'em todos os exercícios' : 'no exercício' }}</span>
          <span class="badge-count">{{ formatInteiro(totalDesconsideradas) }} desconsideradas</span>
          <span class="badge-count">{{ formatInteiro(totalPendentes) }} pendentes</span>
        </div>
      </div>

      <!-- ─── Erro na consulta ───────────────────────────────── -->
      <div v-if="erro" class="alert-erro">
        <div class="alert-erro__icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 8v5M12 16h.01"/>
          </svg>
        </div>
        <div class="alert-erro__body">
          <p class="alert-erro__title">{{ erroTitulo }}</p>
          <p class="alert-erro__desc">{{ erro }}</p>
        </div>
        <button v-if="erroRecarregavel" type="button" class="alert-erro__btn" :disabled="httpSend"
                @click="pesquisar">
          Tentar novamente
        </button>
      </div>

      <!-- ─── Filtros ──────────────────────────────────────── -->
      <div class="filtros-card">
        <div class="filtros-header">
          <div class="header-left-group">
            <p class="chart-title">Filtros</p>
            <span v-if="filtrosAtivos > 0" class="badge-count badge-count--ativo">
              {{ filtrosAtivos }} {{ filtrosAtivos === 1 ? 'filtro ativo' : 'filtros ativos' }}
            </span>
          </div>
          <button v-if="filtrosAtivos > 0" type="button" class="btn-limpar" @click="limparFiltros">
            Limpar filtros
          </button>
        </div>

        <div class="filtros-grid">
          <div class="campo">
            <label for="f-exercicio">Exercício</label>
            <select id="f-exercicio" v-model="filtros.exercicio" class="campo-input"
                    :disabled="listaExercicio.length === 0">
              <option value="todos">Todos</option>
              <option v-for="exercicio in listaExercicio" :key="exercicio" :value="exercicio">
                {{ exercicio }}
              </option>
            </select>
          </div>
          <div class="campo">
            <label for="f-tipo">Tipo de análise</label>
            <select id="f-tipo" v-model="filtros.tipo" class="campo-input">
              <option value="todos">Todos os tipos</option>
              <option v-for="tipo in opcoesTipo" :key="tipo.codigo" :value="tipo.codigo">
                {{ tipo.codigo }} — {{ tipo.descricao }}
              </option>
            </select>
          </div>
          <div class="campo">
            <label for="f-situacao">Situação da análise</label>
            <select id="f-situacao" v-model="filtros.situacao" class="campo-input">
              <option value="todos">Todos</option>
              <option value="analisados">Analisados</option>
              <option value="nao_analisados">Não Analisados</option>
            </select>
          </div>
        </div>
      </div>

      <!-- ─── Tabela ───────────────────────────────────────── -->
      <div ref="tabela" class="table-card">
        <div class="table-header">
          <div class="header-left-group">
            <p class="chart-title">Divergências apuradas</p>
            <span class="badge-count">
              {{ formatInteiro(registrosFiltrados.length) }}
              {{ registrosFiltrados.length === 1 ? 'registro' : 'registros' }}
            </span>
            <span v-if="registrosFiltrados.length !== divergencias.length" class="badge-count badge-count--ativo">
              de {{ formatInteiro(divergencias.length) }}
            </span>
          </div>
          <div class="header-right-group">
            <button v-if="!carregando && registrosFiltrados.length > 0" type="button" class="btn-lote"
                    :disabled="!podeAlterarLote" :title="dicaLote" @click="confirmarLote">
              <span v-if="salvandoLote" class="check-loader check-loader--btn"/>
              <svg v-else width="13" height="13" viewBox="0 0 16 16" fill="none">
                <rect x="1.5" y="1.5" width="13" height="13" rx="3" stroke="currentColor" stroke-width="1.4"/>
                <path v-if="marcarTodos" d="M4.5 8.2l2.2 2.3 4.8-5" stroke="currentColor" stroke-width="1.6"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path v-else d="M5 8h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
              {{ rotuloLote }}
            </button>
            <select v-model="porPagina" class="campo-input campo-input--pp">
              <option :value="10">10 por página</option>
              <option :value="25">25 por página</option>
              <option :value="50">50 por página</option>
              <option :value="100">100 por página</option>
            </select>
          </div>
        </div>

        <div v-if="carregando" class="sk-table">
          <div v-for="n in 8" :key="`skr-${n}`" class="sk-row"/>
        </div>

        <div v-else class="table-wrapper">
          <table v-if="registrosPagina.length > 0" class="nf-table nf-table--divergencias">
            <thead>
            <tr>
              <th class="col-fixa col-competencia">Competência</th>
              <th class="col-fixa col-tipo th-center">Tipo</th>
              <th>Nome da Análise</th>
              <th>Declaração DAS-D</th>
              <th class="th-right">Alíquota (%)</th>
              <th>Referência</th>
              <th class="th-right">Base NFS-e</th>
              <th class="th-right">Cálculo DAS-D</th>
              <th class="th-right">Diferença</th>
              <th class="th-right">Potencial</th>
              <th class="th-center">Desconsiderar</th>
              <th>Fiscal</th>
              <th>Última Atualização</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="registro in registrosPagina" :key="registro.chave"
                :class="{ 'row--desconsiderada': registro.desconsiderado }">
              <td class="col-fixa col-competencia td-mono">{{ registro.competencia || '—' }}</td>
              <td class="col-fixa col-tipo td-center">
                <span class="pill-divergencias">{{ registro.tipo }}</span>
              </td>
              <td class="td-analise">
                <div class="cell-stack">
                  <span class="cell-primary">{{ registro.nomeAnalise }}</span>
                  <span class="tag-situacao" :class="registro.analisado ? 'tag-situacao--ok' : ''">
                    {{ registro.analisado ? 'Analisada' : 'Não analisada' }}
                  </span>
                </div>
              </td>
              <td class="td-mono">
                <span v-if="registro.declaracao">{{ registro.declaracao }}</span>
                <span v-else class="td-muted" title="Não informada">—</span>
              </td>
              <td class="td-right td-valor">{{ formatAliquota(registro.aliquota) }}</td>
              <td>
                <span v-if="registro.referencia">{{ registro.referencia }}</span>
                <span v-else class="td-muted">—</span>
              </td>
              <td class="td-right td-valor">{{ formatMoeda(registro.baseNfse) }}</td>
              <td class="td-right td-valor">{{ formatMoeda(registro.calculoDasd) }}</td>
              <td class="td-right td-valor">{{ formatMoeda(registro.diferenca) }}</td>
              <td class="td-right td-potencial">{{ formatMoeda(registro.potencial) }}</td>
              <td class="td-center">
                <span class="check-wrap">
                  <!-- O input permanece no DOM (v-show) para que o estado possa ser revertido se a gravação falhar. -->
                  <input
                      v-show="!salvando[registro.chave]"
                      type="checkbox"
                      class="check-desconsiderar"
                      :checked="registro.desconsiderado"
                      :disabled="!!salvando[registro.chave]"
                      :aria-label="`Desconsiderar divergência ${registro.competencia} tipo ${registro.tipo}`"
                      @change="alternarDesconsiderar(registro, $event)"
                  >
                  <span v-if="salvando[registro.chave]" class="check-loader" role="status"
                        title="Salvando alteração..." aria-label="Salvando alteração"/>
                </span>
              </td>
              <td>
                <div v-if="registro.fiscalNome" class="cell-stack">
                  <span class="cell-primary cell-nowrap">{{ registro.fiscalNome }}</span>
                  <span v-if="registro.fiscalData" class="cell-secundaria">
                    {{ formatDataHora(registro.fiscalData) }}
                  </span>
                </div>
                <span v-else class="td-muted">—</span>
              </td>
              <td class="cell-nowrap">{{ formatDataHora(registro.atualizadoEm) }}</td>
            </tr>
            </tbody>
          </table>

          <!-- Estado vazio -->
          <div v-else class="empty-state">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <circle cx="18" cy="18" r="17" stroke="#e2e8f0" stroke-width="1.5"/>
              <path d="M12 18h12M18 12v12" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <p v-if="registros.length === 0">Nenhuma divergência apurada para esta empresa</p>
            <p v-else-if="divergencias.length === 0">
              Nenhuma divergência apurada para esta empresa no exercício {{ filtros.exercicio }}
            </p>
            <p v-else>Nenhuma divergência encontrada para os filtros aplicados</p>
            <button v-if="filtrosAtivos > 0" type="button" class="btn-limpar" @click="limparFiltros">
              Limpar filtros
            </button>
          </div>
        </div>

        <div v-if="!carregando && registrosFiltrados.length > 0" class="table-footer">
          <span class="table-footer__info">
            Exibindo {{ formatInteiro(primeiroDaPagina) }}–{{ formatInteiro(ultimoDaPagina) }}
            de {{ formatInteiro(registrosFiltrados.length) }}
          </span>
          <paginate
              v-if="totalPaginas > 1"
              v-model="pagina"
              :page-count="totalPaginas"
              :page-range="3"
              :margin-pages="2"
              :click-handler="proximaPagina"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :container-class="'pagination pagination-rounded mb-0'"
              :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import moment from "moment";
import Swal from "sweetalert2";
import Paginate from 'vuejs-paginate';
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import tiposAnalise from "@/dados/tipos-analise-simples.json";
import Aguarde from "@/components/widgets/aguarde.vue";
import {notifySucesso} from "@/helps/notificacao";
import {
  desconsiderar_simples_nacional_divergencia,
  list_simples_nacional_divergencias
} from "@/api/admin/fiscalizacao/simples_nacional_divergencias";

const ROTA_APURACAO = 'admin-fiscalizacao-simples-nacional';

export default {
  page: {
    title: "Divergências do Simples Nacional",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Aguarde,
    Layout,
    Paginate,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Guarda a consulta da apuração para restaurar os filtros ao voltar.
      if (from.name === ROTA_APURACAO) vm.retorno = {name: from.name, query: {...from.query}};
    });
  },
  data() {
    return {
      title: "Divergências do Simples Nacional",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Fiscalização do Simples Nacional',
          href: '/admin/fiscalizacao/simples_nacional',
        },
        {
          text: 'Divergências',
          active: true,
        },
      ],
      httpSend: false,
      carregando: true,
      erro: null,
      erroTitulo: '',
      erroRecarregavel: false,
      retorno: null,
      apuracao: [],
      // Chaves das divergências com gravação em andamento (exibem o loader no checkbox).
      salvando: {},
      salvandoLote: false,
      filtros: {
        exercicio: "todos",
        tipo: "todos",
        situacao: "todos",
      },
      pagina: 1,
      porPagina: 100,
    };
  },
  computed: {
    empresa() {
      const query = this.$route.query || {};
      const codigos = this.apuracao
          .map(item => this.textoOuNulo(item.eco_codigo))
          .filter((codigo, indice, lista) => codigo && lista.indexOf(codigo) === indice);
      return {
        cnpj: this.somenteDigitos(this.$route.params.esr_cnpj),
        nome: this.textoOuNulo(query.nome),
        codigo: codigos.length ? codigos.join(', ') : this.textoOuNulo(query.eco_codigo),
      };
    },
    // ─── Normalização dos dados da API ────────────────────
    registros() {
      const nomesCatalogo = tiposAnalise.reduce((mapa, tipo) => {
        mapa[tipo.codigo] = tipo.descricao;
        return mapa;
      }, {});
      return this.apuracao.map(item => {
        const competencia = this.formatCompetencia(item.esr_competencia);
        const tipo = this.textoOuNulo(item.srt_codigo) || '';
        const chave = this.chaveDivergencia(item);
        const analisado = this.paraBooleano(item.esr_analisado);
        return {
          chave,
          competencia,
          // Chave da divergência na API, usada para gravar a desconsideração.
          cnpj: this.textoOuNulo(item.esr_cnpj),
          competenciaApi: this.paraNumeroOuNulo(item.esr_competencia),
          exercicio: competencia ? parseInt(competencia.slice(0, 4), 10) : null,
          tipo,
          nomeAnalise: this.textoOuNulo(item.srt_descricao) || nomesCatalogo[tipo] || `Tipo ${tipo}`,
          declaracao: this.textoOuNulo(item.esr_das),
          // A API envia a alíquota como fração (0.02 = 2,00%).
          aliquota: this.paraNumeroOuNulo(item.esr_aliquota) === null ? null : this.paraNumero(item.esr_aliquota) * 100,
          referencia: this.textoOuNulo(item.esr_aliquota_metodo),
          baseNfse: this.paraNumeroOuNulo(item.esr_base_nfs),
          calculoDasd: this.paraNumeroOuNulo(item.esr_base_das),
          diferenca: this.paraNumeroOuNulo(item.esr_diferenca),
          potencial: this.paraNumeroOuNulo(item.esr_potencial),
          analisado,
          // Desconsiderar uma divergência é justamente marcá-la como analisada pelo fiscal.
          desconsiderado: analisado,
          // Fiscal e data da análise: exibidos somente quando a divergência foi analisada.
          fiscalCodigo: analisado ? this.paraNumeroOuNulo(item.aut_codigo) : null,
          fiscalNome: analisado ? this.textoOuNulo(item.pes_nome) : null,
          fiscalData: analisado ? this.textoOuNulo(item.esr_data_analise) : null,
          atualizadoEm: this.textoOuNulo(item.esr_atualizado) || this.textoOuNulo(item.log_datainclusao),
        };
      });
    },
    listaExercicio() {
      return this.registros
          .map(registro => registro.exercicio)
          .filter((exercicio, indice, lista) => exercicio && lista.indexOf(exercicio) === indice)
          .sort((a, b) => b - a);
    },
    exercicioPadrao() {
      return 'todos';
    },
    // Catálogo do requisito + qualquer outro tipo retornado pela apuração.
    opcoesTipo() {
      const opcoes = tiposAnalise.map(tipo => ({...tipo}));
      this.registros.forEach(registro => {
        if (registro.tipo && !opcoes.some(opcao => opcao.codigo === registro.tipo)) {
          opcoes.push({codigo: registro.tipo, descricao: registro.nomeAnalise});
        }
      });
      return opcoes.sort((a, b) => this.paraNumero(a.codigo) - this.paraNumero(b.codigo));
    },
    // ─── Filtros ──────────────────────────────────────────
    divergencias() {
      if (this.filtros.exercicio === 'todos') return this.registros;
      return this.registros.filter(registro => registro.exercicio === this.filtros.exercicio);
    },
    registrosFiltrados() {
      const {tipo, situacao} = this.filtros;
      return this.divergencias.filter(registro => {
        if (tipo !== 'todos' && registro.tipo !== tipo) return false;
        if (situacao === 'analisados' && !registro.analisado) return false;
        if (situacao === 'nao_analisados' && registro.analisado) return false;
        return true;
      });
    },
    filtrosAtivos() {
      let total = 0;
      if (this.filtros.exercicio !== this.exercicioPadrao) total++;
      if (this.filtros.tipo !== 'todos') total++;
      if (this.filtros.situacao !== 'todos') total++;
      return total;
    },
    totalDesconsideradas() {
      return this.divergencias.filter(registro => registro.desconsiderado).length;
    },
    totalPendentes() {
      return this.divergencias.filter(registro => !registro.desconsiderado).length;
    },
    // ─── Ação em lote ─────────────────────────────────────
    // Enquanto houver alguma divergência pendente na tabela, o botão desconsidera todas.
    marcarTodos() {
      return this.registrosFiltrados.some(registro => !registro.desconsiderado);
    },
    // Apenas as linhas que realmente mudam de situação são enviadas à API.
    registrosLote() {
      return this.registrosFiltrados.filter(registro => registro.desconsiderado !== this.marcarTodos);
    },
    rotuloLote() {
      return this.marcarTodos ? 'Desconsiderar todas' : 'Reconsiderar todas';
    },
    dicaLote() {
      const total = this.formatInteiro(this.registrosLote.length);
      return this.marcarTodos
          ? `Desconsiderar as ${total} divergências pendentes da tabela`
          : `Reconsiderar as ${total} divergências desconsideradas da tabela`;
    },
    podeAlterarLote() {
      return !this.salvandoLote && !this.carregando && this.registrosLote.length > 0;
    },
    // ─── Ordenação e paginação ────────────────────────────
    registrosOrdenados() {
      return this.registrosFiltrados.slice().sort((a, b) => {
        const competencia = String(a.competencia).localeCompare(String(b.competencia));
        if (competencia !== 0) return competencia;
        return this.paraNumero(a.tipo) - this.paraNumero(b.tipo);
      });
    },
    registrosPagina() {
      const inicio = (this.pagina - 1) * this.porPagina;
      return this.registrosOrdenados.slice(inicio, inicio + this.porPagina);
    },
    totalPaginas() {
      return Math.ceil(this.registrosFiltrados.length / this.porPagina) || 0;
    },
    primeiroDaPagina() {
      if (!this.registrosFiltrados.length) return 0;
      return (this.pagina - 1) * this.porPagina + 1;
    },
    ultimoDaPagina() {
      return Math.min(this.pagina * this.porPagina, this.registrosFiltrados.length);
    },
  },
  watch: {
    filtros: {
      deep: true,
      handler() {
        this.pagina = 1;
      },
    },
    porPagina() {
      this.pagina = 1;
    },
    totalPaginas(valor) {
      if (valor > 0 && this.pagina > valor) this.pagina = valor;
    },
  },
  created() {
    this.pesquisar();
  },
  methods: {
    // ─── Obtenção dos dados ───────────────────────────────
    pesquisar() {
      this.httpSend = true;
      this.erro = null;
      list_simples_nacional_divergencias(this.empresa.cnpj).then(result => {
        if (result && result.status) {
          this.apuracao = Array.isArray(result.dados) ? result.dados : [];
          if (this.filtros.exercicio !== 'todos' && this.listaExercicio.indexOf(this.filtros.exercicio) === -1) {
            this.filtros.exercicio = this.exercicioPadrao;
          }
        } else {
          this.apuracao = [];
          this.mostrarErro('Não foi possível carregar as divergências',
              (result && result.mensagem) || 'A consulta não retornou dados válidos.', true);
        }
      }).catch(error => {
        console.error(error);
        this.apuracao = [];
        this.mostrarErro('Não foi possível carregar as divergências',
            'Falha de comunicação com o servidor. Verifique sua conexão e tente novamente.', true);
      }).finally(() => {
        this.httpSend = false;
        this.carregando = false;
      });
    },
    mostrarErro(titulo, mensagem, recarregavel) {
      this.erroTitulo = titulo;
      this.erro = mensagem;
      this.erroRecarregavel = recarregavel;
    },
    chaveDivergencia(item) {
      return [item.esr_cnpj, item.eco_codigo, item.esr_competencia, item.esr_sequencia, item.srt_codigo]
          .map(valor => (valor === null || valor === undefined ? '' : String(valor)))
          .join('|');
    },
    // ─── Desconsiderar ────────────────────────────────────
    /*
     * Grava a marcação na API e atualiza somente a linha alterada, com o nome do
     * fiscal e a data/hora devolvidos pelo servidor — sem recarregar a consulta.
     */
    alternarDesconsiderar(registro, evento) {
      const chave = registro.chave;
      const marcado = evento.target.checked;
      // Ignora cliques repetidos enquanto a alteração anterior não terminou.
      if (this.salvando[chave] || marcado === registro.desconsiderado) {
        evento.target.checked = registro.desconsiderado;
        return;
      }
      this.$set(this.salvando, chave, true);
      this.erro = null;
      desconsiderar_simples_nacional_divergencia({
        esr_cnpj: registro.cnpj,
        esr_competencia: registro.competenciaApi,
        srt_codigo: registro.tipo,
        esr_analisado: marcado,
      }).then(result => {
        if (result && result.status) {
          this.aplicarDesconsideracao(chave, result.dados, marcado);
        } else {
          evento.target.checked = registro.desconsiderado;
          this.mostrarErro('Não foi possível alterar a divergência',
              (result && result.mensagem) || 'A alteração não foi registrada.', false);
        }
      }).catch(error => {
        console.error(error);
        evento.target.checked = registro.desconsiderado;
        this.mostrarErro('Não foi possível alterar a divergência',
            'Falha de comunicação com o servidor. Verifique sua conexão e tente novamente.', false);
      }).finally(() => {
        this.$delete(this.salvando, chave);
      });
    },
    /*
     * Desconsidera (ou reconsidera) de uma vez todas as divergências da tabela —
     * respeitando os filtros aplicados — em uma única chamada à API.
     */
    confirmarLote() {
      if (!this.podeAlterarLote) return;
      const marcar = this.marcarTodos;
      const registros = this.registrosLote.slice();
      const total = this.formatInteiro(registros.length);
      const plural = registros.length === 1 ? 'divergência' : 'divergências';
      Swal.fire({
        title: marcar ? 'Desconsiderar todas as divergências?' : 'Reconsiderar todas as divergências?',
        text: marcar
            ? `${total} ${plural} da tabela serão marcadas como analisadas em seu nome.`
            : `${total} ${plural} da tabela voltarão para a situação de não analisadas.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#100e0e",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      }).then(result => {
        if (result.isConfirmed) this.alterarLote(registros, marcar);
      });
    },
    alterarLote(registros, marcar) {
      this.salvandoLote = true;
      this.erro = null;
      // Cada linha do lote exibe o loader no próprio checkbox.
      registros.forEach(registro => this.$set(this.salvando, registro.chave, true));
      desconsiderar_simples_nacional_divergencia({
        esr_analisado: marcar,
        divergencias: registros.map(registro => ({
          esr_cnpj: registro.cnpj,
          esr_competencia: registro.competenciaApi,
          srt_codigo: registro.tipo,
        })),
      }).then(result => {
        if (result && result.status) {
          this.aplicarLote(Array.isArray(result.dados) ? result.dados : [], marcar);
          notifySucesso(marcar ? 'Divergências desconsideradas' : 'Divergências reconsideradas',
              result.mensagem || '');
        } else {
          this.mostrarErro('Não foi possível alterar as divergências',
              (result && result.mensagem) || 'A alteração não foi registrada.', false);
        }
      }).catch(error => {
        console.error(error);
        this.mostrarErro('Não foi possível alterar as divergências',
            'Falha de comunicação com o servidor. Verifique sua conexão e tente novamente.', false);
      }).finally(() => {
        registros.forEach(registro => this.$delete(this.salvando, registro.chave));
        this.salvandoLote = false;
      });
    },
    // Aplica na linha o registro devolvido pela API (fiscal, data da análise e situação).
    aplicarDesconsideracao(chave, dados, marcado) {
      const indice = this.apuracao.findIndex(item => this.chaveDivergencia(item) === chave);
      if (indice === -1) return;
      this.$set(this.apuracao, indice, this.mesclarGravado(this.apuracao[indice], dados, marcado));
    },
    // Idem, para o lote: uma única reconstrução da lista com todos os registros gravados.
    aplicarLote(dados, marcado) {
      if (!dados.length) return;
      const porChave = new Map();
      dados.forEach(gravado => porChave.set(this.chaveDivergencia(gravado), gravado));
      this.apuracao = this.apuracao.map(item => {
        const gravado = porChave.get(this.chaveDivergencia(item));
        return gravado ? this.mesclarGravado(item, gravado, marcado) : item;
      });
    },
    mesclarGravado(item, dados, marcado) {
      const gravado = dados || {};
      return {
        ...item,
        esr_analisado: gravado.esr_analisado === undefined ? marcado : gravado.esr_analisado,
        aut_codigo: gravado.aut_codigo === undefined ? null : gravado.aut_codigo,
        pes_nome: gravado.pes_nome === undefined ? null : gravado.pes_nome,
        esr_data_analise: gravado.esr_data_analise === undefined ? null : gravado.esr_data_analise,
        esr_atualizado: gravado.esr_atualizado === undefined ? item.esr_atualizado : gravado.esr_atualizado,
      };
    },
    // ─── Filtros ──────────────────────────────────────────
    limparFiltros() {
      this.filtros = {
        exercicio: this.exercicioPadrao,
        tipo: 'todos',
        situacao: 'todos',
      };
    },
    // ─── Navegação ────────────────────────────────────────
    voltar() {
      this.$router.push(this.retorno || {name: ROTA_APURACAO}).catch(() => {
      });
    },
    proximaPagina(numeroPagina) {
      this.$refs.tabela.scrollIntoView({behavior: 'smooth', block: 'start'})
      this.pagina = parseInt(numeroPagina, 10) || 1;
    },
    // ─── Conversão e formatação ───────────────────────────
    paraNumero(valor) {
      if (valor === null || valor === undefined || valor === '') return 0;
      const numero = Number(valor);
      return isNaN(numero) ? 0 : numero;
    },
    paraNumeroOuNulo(valor) {
      if (valor === null || valor === undefined || valor === '') return null;
      const numero = Number(valor);
      return isNaN(numero) ? null : numero;
    },
    // O driver do Postgres pode devolver booleanos como 't'/'f'.
    paraBooleano(valor) {
      if (typeof valor === 'boolean') return valor;
      return ['t', 'true', 's', '1'].indexOf(String(valor).trim().toLowerCase()) !== -1;
    },
    textoOuNulo(valor) {
      if (valor === null || valor === undefined) return null;
      const texto = String(valor).trim();
      return texto === '' ? null : texto;
    },
    somenteDigitos(valor) {
      if (valor === null || valor === undefined) return '';
      return String(valor).replace(/\D/g, '');
    },
    // Aceita "2026-08-24 11:47:35-03", "2026-08-24 11:47:35.000 -0300" e similares.
    paraData(valor) {
      const texto = this.textoOuNulo(valor);
      if (!texto) return null;
      const iso = texto.replace(' ', 'T').replace(/\s+(?=[+-]\d{2}:?\d{0,2}$)/, '');
      const data = moment(iso, moment.ISO_8601);
      return data.isValid() ? data : null;
    },
    formatDataHora(valor) {
      const data = this.paraData(valor);
      return data ? data.format('DD/MM/YYYY HH:mm') : '—';
    },
    // Valores ausentes são exibidos como "—" para não sugerir R$ 0,00.
    formatMoeda(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      return this.paraNumero(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatAliquota(valor) {
      if (valor === null || valor === undefined || valor === '') return '—';
      return this.paraNumero(valor).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatInteiro(valor) {
      return this.paraNumero(valor).toLocaleString('pt-BR', {maximumFractionDigits: 0});
    },
    // 202302 → 2023-02
    formatCompetencia(valor) {
      const partes = String(valor === null || valor === undefined ? '' : valor).match(/^(\d{4})-?(\d{1,2})$/);
      if (!partes) return null;
      return `${partes[1]}-${partes[2].padStart(2, '0')}`;
    },
    formatCnpj(valor) {
      const digitos = this.somenteDigitos(valor);
      if (digitos.length === 11) {
        return digitos.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
      }
      if (digitos.length === 14) {
        return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
      }
      return digitos || '—';
    },
    // ─── Ícones ───────────────────────────────────────────
    iconEmpresa() {
      return `<svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <rect x="2.5" y="3" width="13" height="12" rx="1.6" stroke="currentColor" stroke-width="1.4"/>
        <path d="M6 6.5h2M6 9h2M10 6.5h2M10 9h2M7.5 15v-2.5h3V15" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      </svg>`;
    },
  },
};
</script>

<style scoped>
/* ─── Base ───────────────────────────────────────────────── */
.fisc-sn {
  width: 100%;
  color: #0f172a;
}

/* ─── Cabeçalho ──────────────────────────────────────────── */
.page-intro {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
}

.page-intro__title {
  margin: 0 0 2px;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.page-intro__sub {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
}

.btn-voltar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  padding: 0;
  background: none;
  border: none;
  font-size: 12px;
  font-weight: 500;
  color: #4f6ef7;
  cursor: pointer;
}

.btn-voltar:hover {
  text-decoration: underline;
}

/* ─── Empresa ────────────────────────────────────────────── */
.empresa-card {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  margin-bottom: 1.25rem;
}

.empresa-card__body {
  flex: 1;
  min-width: 200px;
}

.empresa-card__nome {
  margin: 0 0 2px;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.empresa-card__info {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.empresa-card__resumo {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.metric-icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.metric-icon--blue {
  background: #eff6ff;
  color: #3b82f6;
}

/* ─── Erro ───────────────────────────────────────────────── */
.alert-erro {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff8f8;
  border: 1px solid #fee2e2;
  border-left: 4px solid #ef4444;
  border-radius: 10px;
  padding: 14px 1.25rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.alert-erro__icon {
  color: #dc2626;
  display: flex;
  flex-shrink: 0;
}

.alert-erro__body {
  flex: 1;
  min-width: 200px;
}

.alert-erro__title {
  margin: 0 0 2px;
  font-size: 13px;
  font-weight: 600;
  color: #991b1b;
}

.alert-erro__desc {
  margin: 0;
  font-size: 12px;
  color: #b91c1c;
}

.alert-erro__btn {
  background: #dc2626;
  border: 1px solid #dc2626;
  border-radius: 7px;
  color: #fff;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.alert-erro__btn:disabled {
  opacity: 0.6;
  cursor: default;
}

/* ─── Skeleton ───────────────────────────────────────────── */
.sk-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 1rem 1.5rem;
}

.sk-row {
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(90deg, #eef2f6 25%, #f8fafc 50%, #eef2f6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* ─── Filtros ────────────────────────────────────────────── */
.chart-title {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.filtros-card {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 1.25rem;
  overflow: hidden;
}

.filtros-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 1rem 1.5rem;
  border-bottom: 0.5px solid #f1f5f9;
  flex-wrap: wrap;
}

.filtros-grid {
  display: grid;
  grid-template-columns: 160px minmax(0, 2fr) minmax(0, 1fr);
  gap: 12px 14px;
  padding: 1.15rem 1.5rem;
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.campo label {
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.campo-input {
  width: 100%;
  border: 0.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: #334155;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.campo-input:focus {
  outline: none;
  border-color: #4f6ef7;
  box-shadow: 0 0 0 3px rgba(79, 110, 247, 0.12);
}

.btn-limpar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #64748b;
  border: 0.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 7px 16px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.btn-limpar:hover {
  background: #f8fafc;
  color: #334155;
}

/* ─── Tabela ─────────────────────────────────────────────── */
.table-card {
  background: #fff;
  border: 0.5px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: 0.5px solid #f1f5f9;
  flex-wrap: wrap;
  gap: 10px;
}

.header-left-group,
.header-right-group {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.badge-count {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 3px 10px;
  white-space: nowrap;
}

.badge-count--ativo {
  color: #4f6ef7;
  background: #eef2ff;
}

.campo-input--pp {
  width: auto;
  font-size: 12px;
  padding: 8px 10px;
  color: #64748b;
}

.table-wrapper {
  overflow-x: auto;
}

.nf-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12px;
}

.nf-table th {
  padding: 9px 1rem;
  background: #f8fafc;
  text-align: left;
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.th-right,
.td-right {
  text-align: right;
}

.th-center,
.td-center {
  text-align: center;
}

.nf-table td {
  padding: 9px 1rem;
  background: #fff;
  border-top: 0.5px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}

.nf-table tbody tr:hover td {
  background: #f8fafc;
}

/* Colunas de identificação fixas na rolagem horizontal */
.col-fixa {
  position: sticky;
  z-index: 1;
}

.col-competencia {
  left: 0;
  min-width: 112px;
  width: 112px;
}

.col-tipo {
  left: 112px;
  min-width: 72px;
  width: 72px;
  box-shadow: inset -1px 0 0 #e2e8f0;
}

.td-analise {
  min-width: 260px;
}

.row--desconsiderada td:not(.col-fixa):not(.td-center) {
  color: #94a3b8;
}

.row--desconsiderada .td-potencial {
  color: #a5b4fc;
  text-decoration: line-through;
}

.cell-stack {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.35;
}

.cell-primary {
  font-weight: 500;
  color: #0f172a;
}

.row--desconsiderada .cell-primary {
  color: #64748b;
}

.cell-primary--ausente {
  color: #94a3b8;
  font-style: italic;
}

.cell-secundaria {
  font-size: 11px;
  color: #94a3b8;
  white-space: nowrap;
}

.cell-nowrap {
  white-space: nowrap;
}

.tag-situacao {
  font-size: 10px;
  font-weight: 500;
  color: #b45309;
  background: #fffbeb;
  border-radius: 4px;
  padding: 1px 6px;
  align-self: flex-start;
}

.tag-situacao--ok {
  color: #047857;
  background: #ecfdf5;
}

.td-mono {
  font-family: 'DM Mono', monospace;
  font-size: 12px;
  color: #475569;
  white-space: nowrap;
}

.td-muted {
  color: #94a3b8;
}

.td-valor {
  font-weight: 500;
  white-space: nowrap;
}

.td-potencial {
  font-weight: 700;
  font-size: 13px;
  color: #4338ca;
  white-space: nowrap;
}

.pill-divergencias {
  display: inline-block;
  min-width: 30px;
  padding: 2px 9px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #334155;
  font-size: 11px;
  font-weight: 600;
}

.check-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.check-desconsiderar {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #4f6ef7;
}

/* ─── Ação em lote ───────────────────────────────────────── */
.btn-lote {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  color: #4f6ef7;
  border: 0.5px solid #c7d2fe;
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}

.btn-lote:hover:not(:disabled) {
  background: #eef2ff;
}

.btn-lote:disabled {
  color: #94a3b8;
  border-color: #e2e8f0;
  cursor: default;
}

/* Loader exibido no lugar do checkbox enquanto a alteração é gravada. */
.check-loader {
  width: 14px;
  height: 14px;
  border: 2px solid #e2e8f0;
  border-top-color: #4f6ef7;
  border-radius: 50%;
  animation: check-spin 0.7s linear infinite;
}

.check-loader--btn {
  border-color: #c7d2fe;
  border-top-color: #4f6ef7;
}

@keyframes check-spin {
  to {
    transform: rotate(360deg);
  }
}

.check-desconsiderar:disabled {
  cursor: progress;
  opacity: 0.5;
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 0.9rem 1.5rem;
  border-top: 0.5px solid #f1f5f9;
}

.table-footer__info {
  font-size: 12px;
  color: #94a3b8;
}

/* ─── Estado vazio ───────────────────────────────────────── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 3rem;
  color: #94a3b8;
  font-size: 13px;
  text-align: center;
}

.empty-state p {
  margin: 0;
}

/* ─── Responsividade ─────────────────────────────────────── */
@media (max-width: 992px) {
  .filtros-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .filtros-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .header-right-group {
    width: 100%;
  }

  /* Em telas estreitas as colunas fixas ocupariam boa parte da área útil. */
  .col-fixa {
    position: static;
  }
}
</style>
